import { userUsergroupsActions } from '../constants';

export const fetchFilteredGroups = (category, page, pageSize, append, filter, filterLength, requiresFilter, user) => ({
  type: userUsergroupsActions.FETCH_FILTERED_GROUPS,
  category,
  page,
  pageSize,
  append,
  filter,
  minFilterLength: filterLength,
  requiresFilter,
  user,
});

export const updateUsersUsergroupProperties = (category, user, properties) => ({
  type: userUsergroupsActions.UPDATE_USERS_USERGROUP_PROPERTIES,
  category,
  user,
  properties,
});

export const showFilteredGroups = (category, user, results) => ({
  type: userUsergroupsActions.SHOW_FILTERED_GROUPS,
  category,
  user,
  results,
});

export const showFilteredGroupsError = (category, user, error) => ({
  type: userUsergroupsActions.SHOW_FILTERED_GROUPS_ERROR,
  category,
  user,
  error,
});

export const toggleAssignUsersToUserGroupSelected = (category, code) => ({
  type: userUsergroupsActions.TOGGLE_ASSIGN_USERS_TO_USER_GROUP_SELECTED,
  category,
  code,
});

export const fetchUsersGroups = (category, user, page, pageSize) => ({
  type: userUsergroupsActions.FETCH_USERS_GROUPS,
  category,
  user,
  page,
  pageSize,
});

export const showUsersGroups = (category, user, results, resultsCount, totalPages, currentPage) => ({
  type: userUsergroupsActions.SHOW_USERS_GROUPS,
  category,
  user,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showUsersGroupsError = (category, user, error) => ({
  type: userUsergroupsActions.SHOW_USERS_GROUPS_ERROR,
  category,
  user,
  error,
});

export const removeUsersGroup = (category, user, group) => ({
  type: userUsergroupsActions.REMOVE_USERS_GROUP,
  category,
  user,
  group,
});

export const removeUsersGroupSuccess = (category, user, group) => ({
  type: userUsergroupsActions.REMOVE_USERS_GROUP_SUCCESS,
  category,
  user,
  group,
});

export const removeUsersGroupError = (category, user, group, error) => ({
  type: userUsergroupsActions.REMOVE_USERS_GROUP_ERROR,
  category,
  user,
  group,
  error,
});

export const removeUsersGroupLocal = (category, user, group) => ({
  type: userUsergroupsActions.REMOVE_USERS_GROUP_LOCAL,
  category,
  user,
  group,
});

export const updateUsersGroupsToAdd = (category, user, groups) => ({
  type: userUsergroupsActions.UPDATE_USERS_GROUPS_TO_ADD,
  category,
  user,
  groups,
});

export const addUsersGroups = (category, user, groups) => ({
  type: userUsergroupsActions.ADD_USERS_GROUPS,
  category,
  user,
  groups,
});

export const addUsersGroupsSuccess = (category, user, groups) => ({
  type: userUsergroupsActions.ADD_USERS_GROUPS_SUCCESS,
  category,
  user,
  groups,
});

export const addUsersGroupsError = (category, user, groups, errors) => ({
  type: userUsergroupsActions.ADD_USERS_GROUPS_ERROR,
  category,
  user,
  groups,
  errors,
});

export const addUsersGroupsLocal = (category, user, groups) => ({
  type: userUsergroupsActions.ADD_USERS_GROUPS_LOCAL,
  category,
  user,
  groups,
});

export const dismissUsersGroupsError = (category, user) => ({
  type: userUsergroupsActions.DISMISS_USERS_GROUPS_ERROR,
  category,
  user,
});
